(function () {
  'use strict';

  var API_URL = 'https://api.zarena.bg/orders/one-click';

  var overlay = document.getElementById('one-click-buy-modal');
  var itemsContainer = document.getElementById('one-click-modal__items');
  var phoneInput = document.getElementById('one-click-phone');
  var phoneError = document.getElementById('one-click-phone-error');
  var submitBtn = document.getElementById('one-click-submit');
  var successEl = document.getElementById('one-click-success');
  var errorStateEl = document.getElementById('one-click-error-state');

  var pendingLineItems = [];
  var pendingSource = '';

  function showOneClickSuccessToast() {
    var toast = document.createElement('div');
    toast.className = 'one-click-toast';
    toast.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#fff"/></svg> ' + (window.__T?.one_click?.toast?.success || 'Expect a call from us!');
    document.body.appendChild(toast);
    // Trigger animation
    requestAnimationFrame(function () {
      toast.classList.add('one-click-toast--visible');
    });
    setTimeout(function () {
      toast.classList.remove('one-click-toast--visible');
      setTimeout(function () { window.location.reload(); }, 400);
    }, 4000);
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Shopify && window.theme.Shopify.formatMoney && window.theme.money_format) {
      return window.theme.Shopify.formatMoney(cents, window.theme.money_format);
    }
    return '€' + (cents / 100).toFixed(2);
  }

  function openModal(lineItems, source) {
    pendingLineItems = lineItems;
    pendingSource = source;

    // Reset state
    phoneInput.value = '';
    phoneError.style.display = 'none';
    submitBtn.style.display = '';
    submitBtn.disabled = false;
    submitBtn.textContent = window.__T?.one_click?.inline?.button || 'Confirm order';
    successEl.style.display = 'none';
    errorStateEl.style.display = 'none';
    overlay.querySelector('.one-click-modal__form').style.display = '';
    overlay.querySelector('.one-click-modal__note').style.display = '';

    // Render items
    itemsContainer.innerHTML = '';
    lineItems.forEach(function (item) {
      var div = document.createElement('div');
      div.className = 'one-click-modal__item';
      div.innerHTML =
        '<span class="one-click-modal__item-name">' + escapeHtml(item.title) + '</span>' +
        '<span class="one-click-modal__item-meta">x' + item.quantity +
        (item.price ? ' &middot; ' + formatMoney(item.price * item.quantity) : '') +
        '</span>';
      itemsContainer.appendChild(div);
    });

    overlay.style.display = 'flex';
    phoneInput.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function validatePhone(raw) {
    // Strip spaces, dashes, parens
    var cleaned = raw.replace(/[\s\-()]/g, '');
    // +359XXXXXXXXX (full international)
    if (/^\+359\d{8,9}$/.test(cleaned)) {
      return cleaned;
    }
    // 00359XXXXXXXXX
    if (/^00359\d{8,9}$/.test(cleaned)) {
      return '+359' + cleaned.slice(5);
    }
    // 0XXXXXXXXX (local format, e.g. 087 123 4567)
    if (/^0\d{8,9}$/.test(cleaned)) {
      return '+359' + cleaned.slice(1);
    }
    // 8 or 9 digits without prefix
    if (/^\d{8,9}$/.test(cleaned)) {
      return '+359' + cleaned;
    }
    return null;
  }

  function handleSubmit() {
    phoneError.style.display = 'none';
    errorStateEl.style.display = 'none';

    var phone = validatePhone(phoneInput.value);
    if (!phone) {
      phoneError.textContent = window.__T?.one_click?.inline?.invalid_phone || 'Please enter a valid phone number.';
      phoneError.style.display = '';
      return;
    }

    if (!pendingLineItems.length) {
      phoneError.textContent = window.__T?.one_click?.inline?.no_products_selected || 'No products selected.';
      phoneError.style.display = '';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = window.__T?.one_click?.inline?.sending || 'Sending...';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        var payload = {
          phone: phone,
          line_items: pendingLineItems.map(function (item) {
            return { variant_id: item.variant_id, quantity: item.quantity };
          }),
          source: pendingSource,
          cart_token: cart && cart.token ? cart.token : null,
          customer_id: window.__CUSTOMER_ID || null
        };

        return fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          overlay.querySelector('.one-click-modal__form').style.display = 'none';
          submitBtn.style.display = 'none';
          overlay.querySelector('.one-click-modal__note').style.display = 'none';
          successEl.style.display = '';
        } else {
          errorStateEl.querySelector('p').textContent = data.error || (window.__T?.one_click?.inline?.error || 'An error occurred. Please try again.');
          errorStateEl.style.display = '';
          submitBtn.disabled = false;
          submitBtn.textContent = window.__T?.one_click?.inline?.button || 'Confirm order';
        }
      })
      .catch(function () {
        errorStateEl.style.display = '';
        submitBtn.disabled = false;
        submitBtn.textContent = window.__T?.one_click?.inline?.button || 'Confirm order';
      });
  }

  // Event listeners
  overlay.querySelector('.one-click-modal__close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  submitBtn.addEventListener('click', handleSubmit);
  phoneInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') handleSubmit();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
  });

  // Product page buttons
  document.querySelectorAll('[data-one-click-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantSelect = document.querySelector('select[name="id"], input[name="id"]');
      var variantId = variantSelect ? parseInt(variantSelect.value) : null;
      var qtyInput = document.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var title = btn.getAttribute('data-product-title') || document.querySelector('.product-single__title')?.textContent?.trim() || 'Product';
      var price = parseInt(btn.getAttribute('data-product-price')) || 0;

      if (!variantId) return;

      openModal([{ variant_id: variantId, quantity: quantity, title: title, price: price }], 'product_page');
    });
  });

  // B2 Split inline 1-click block (PDP) — phone input + submit rendered directly on the page
  document.querySelectorAll('[data-one-click-inline]').forEach(function (block) {
    var input = block.querySelector('[data-one-click-inline-input]');
    var submitBtn = block.querySelector('[data-one-click-inline-submit]');
    var errorEl = block.querySelector('[data-one-click-inline-error]');
    if (!input || !submitBtn) return;

    function digitCount(value) {
      return (value || '').replace(/\D/g, '').length;
    }

    function syncEnabled() {
      submitBtn.disabled = digitCount(input.value) < 6;
    }

    input.addEventListener('input', syncEnabled);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        // Prevent the surrounding add-to-cart form from submitting.
        e.preventDefault();
        if (!submitBtn.disabled) submitBtn.click();
      }
    });
    syncEnabled();

    submitBtn.addEventListener('click', function () {
      errorEl.style.display = 'none';

      var phone = validatePhone(input.value);
      if (!phone) {
        errorEl.textContent = window.__T?.one_click?.inline?.invalid_phone || 'Please enter a valid phone number.';
        errorEl.style.display = '';
        return;
      }

      var variantSelect = document.querySelector('select[name="id"], input[name="id"]');
      var variantId = variantSelect ? parseInt(variantSelect.value) : null;
      if (!variantId) {
        errorEl.textContent = window.__T?.one_click?.inline?.no_variant || 'Please select a product variant.';
        errorEl.style.display = '';
        return;
      }
      var qtyInput = document.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      submitBtn.disabled = true;

      // If this product has a special discount code on its form, activate it
      // server-side first (same flow as the normal Add-to-Cart does in theme.js:4114-4120).
      // Without this, `/cart.js` returns undiscounted totals for codes that are not
      // set up as automatic discounts in Shopify Admin.
      var productForm = document.getElementById('product-form');
      var specialCode = productForm && productForm.dataset.specialDiscountCode;
      var activationPromise = specialCode
        ? fetch('/discount/' + encodeURIComponent(specialCode), { method: 'GET', credentials: 'same-origin' }).catch(function () {})
        : Promise.resolve();

      activationPromise
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
          });
        })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          submitBtn.disabled = false;
          syncEnabled();
          openConfirmModal(phone, cart, null, 'product_page_inline');
        })
        .catch(function () {
          errorEl.textContent = window.__T?.one_click?.inline?.error || 'An error occurred. Please try again.';
          errorEl.style.display = '';
          submitBtn.disabled = false;
          syncEnabled();
        });
    });
  });

  // Trust-row copy switches after office hours on weekdays (Mon–Fri after 16:30 Europe/Sofia).
  (function updateTrustAfterHours() {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
    var day = now.getDay();
    var hours = now.getHours();
    var minutes = now.getMinutes();
    var isAfterHours = day >= 1 && day <= 5 && (hours > 16 || (hours === 16 && minutes >= 30));
    if (!isAfterHours) return;
    document.querySelectorAll('.one-click-inline__trust').forEach(function (row) {
      row.innerHTML =
        '<span class="one-click-inline__trust-item">' +
        '<i class="fa-regular fa-clock" aria-hidden="true"></i> ' +
        (window.__T?.one_click?.trust?.after_hours || 'Expect a call tomorrow after 8:30am') +
        '</span>';
      row.style.justifyContent = 'center';
    });
  })();

  // Confirm modal (shown between drawer ПОРЪЧАЙ click and actual submission)
  var confirmOverlay = document.getElementById('one-click-confirm-modal');
  var confirmItemsEl = document.getElementById('one-click-confirm__items');
  var confirmStartingEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-starting]');
  var confirmDiscountRowEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-discount-row]');
  var confirmDiscountEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-discount]');
  var confirmDiscountCodesEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-discount-codes]');
  var confirmExtraEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-extra]');
  var confirmTotalEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-total]');
  var confirmErrorEl = confirmOverlay && confirmOverlay.querySelector('[data-confirm-error]');
  var confirmSubmitBtn = confirmOverlay && confirmOverlay.querySelector('[data-confirm-submit]');
  var confirmBackBtn = confirmOverlay && confirmOverlay.querySelector('[data-confirm-back]');
  var confirmSubmitDefaultText = confirmSubmitBtn && confirmSubmitBtn.textContent;
  var pendingConfirmContext = null;

  function priceCellHtml(originalCents, finalCents) {
    if (originalCents > finalCents) {
      return '<span class="one-click-confirm__item-price-col">' +
        '<span class="one-click-confirm__item-price-was">' + formatMoney(originalCents) + '</span>' +
        '<span class="one-click-confirm__item-price">' + formatMoney(finalCents) + '</span>' +
        '</span>';
    }
    return '<span class="one-click-confirm__item-price">' + formatMoney(finalCents) + '</span>';
  }

  function renderConfirmSummary(cart) {
    // Line items (excluding the gift product that gets auto-added)
    confirmItemsEl.innerHTML = '';
    cart.items
      .filter(function (item) { return item.product_id !== 8831134531921; })
      .forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'one-click-confirm__item';
        var meta = 'x' + item.quantity;
        if (item.variant_title) meta = meta + ' &middot; ' + escapeHtml(item.variant_title);

        // Strikethrough when a line-level discount or a compare_at_price applies
        var compareLine = item.compare_at_price && item.compare_at_price > item.price
          ? item.compare_at_price * item.quantity
          : 0;
        var originalCents = Math.max(compareLine, item.original_line_price || 0);

        li.innerHTML =
          '<img class="one-click-confirm__item-img" src="' + (item.image || '') + '" alt="">' +
          '<div class="one-click-confirm__item-body">' +
          '<span class="one-click-confirm__item-title">' + escapeHtml(item.product_title || item.title) + '</span>' +
          '<span class="one-click-confirm__item-meta">' + meta + '</span>' +
          '</div>' +
          priceCellHtml(originalCents, item.final_line_price);
        confirmItemsEl.appendChild(li);
      });

    // Cart-page gift rules: mirror `sections/main-cart.liquid` thresholds.
    // Tier-2 gift (Ексклузивен несесер) also shows its original value struck through
    // per `snippets/gift-line-item-200.liquid`.
    var gift = null;
    if (cart.total_price > 20000) {
      gift = { title: confirmOverlay.dataset.neseserLabel || (window.__T?.one_click?.confirm?.free_gift_neseser || 'GIFT - Exclusive pouch'), originalCents: 6900 };
    } else if (cart.total_price > 7500) {
      gift = { title: confirmOverlay.dataset.giftLabel || (window.__T?.one_click?.confirm?.free_gift || 'Free gift'), originalCents: 0 };
    }
    if (gift) {
      var giftLi = document.createElement('li');
      giftLi.className = 'one-click-confirm__item one-click-confirm__item--gift';
      giftLi.innerHTML =
        '<div class="one-click-confirm__item-body">' +
        '<span class="one-click-confirm__item-title">' + escapeHtml(gift.title) + '</span>' +
        '</div>' +
        priceCellHtml(gift.originalCents, 0);
      confirmItemsEl.appendChild(giftLi);
    }

    // Starting price = sum of each item's "was" price × quantity (compare_at_price when on sale,
    // otherwise the regular price). Matches the cart page's `original_amount` calculation in
    // `sections/main-cart.liquid:1-5`.
    var startingPrice = 0;
    cart.items
      .filter(function (item) { return item.product_id !== 8831134531921; })
      .forEach(function (item) {
        var unit = item.compare_at_price && item.compare_at_price > item.price ? item.compare_at_price : item.price;
        startingPrice += unit * item.quantity;
      });

    var existingDiscount = startingPrice - cart.total_price;
    if (existingDiscount < 0) existingDiscount = 0;

    var extraDiscount = Math.round(cart.total_price * 0.05);
    var finalTotal = cart.total_price - extraDiscount;

    confirmStartingEl.textContent = formatMoney(startingPrice);
    if (existingDiscount > 0) {
      confirmDiscountEl.textContent = '-' + formatMoney(existingDiscount);
      confirmDiscountCodesEl.textContent = formatDiscountCodes(cart);
      confirmDiscountRowEl.style.display = '';
    } else {
      confirmDiscountRowEl.style.display = 'none';
    }
    confirmExtraEl.textContent = '-' + formatMoney(extraDiscount);
    confirmTotalEl.textContent = formatMoney(finalTotal);
  }

  function formatDiscountCodes(cart) {
    var codes = [];
    function push(title) {
      if (title && codes.indexOf(title) === -1) codes.push(title);
    }
    if (cart.cart_level_discount_applications) {
      cart.cart_level_discount_applications.forEach(function (d) { push(d.title); });
    }
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        push(alloc.discount_application && alloc.discount_application.title);
      });
    });
    if (!codes.length) return '';
    var prefix = (confirmOverlay && confirmOverlay.dataset.discountCodePrefix) || (window.__T?.one_click?.confirm?.discount_code_prefix || 'code:');
    return ' (' + prefix + ' ' + codes.join(', ') + ')';
  }

  function openConfirmModal(phone, cart, drawerBtn, source) {
    if (!confirmOverlay) return;
    pendingConfirmContext = { phone: phone, cart: cart, drawerBtn: drawerBtn, source: source || 'cart_drawer' };
    confirmErrorEl.style.display = 'none';
    confirmSubmitBtn.disabled = false;
    confirmSubmitBtn.textContent = confirmSubmitDefaultText;
    confirmBackBtn.disabled = false;
    renderConfirmSummary(cart);
    // Move to end of <body> so z-index wins against #added-to-cart (dynamically appended last).
    document.body.appendChild(confirmOverlay);
    confirmOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeConfirmModal(restoreDrawerBtn) {
    if (!confirmOverlay) return;
    confirmOverlay.style.display = 'none';
    document.body.style.overflow = '';
    if (restoreDrawerBtn && pendingConfirmContext && pendingConfirmContext.drawerBtn) {
      pendingConfirmContext.drawerBtn.disabled = false;
      pendingConfirmContext.drawerBtn.textContent = window.__T?.one_click?.drawer?.button || 'ORDER';
    }
    pendingConfirmContext = null;
  }

  function submitOneClickOrder() {
    if (!pendingConfirmContext) return;
    var phone = pendingConfirmContext.phone;
    var cart = pendingConfirmContext.cart;

    var items = cart.items
      .filter(function (item) { return item.product_id !== 8831134531921; })
      .map(function (item) { return { variant_id: item.variant_id, quantity: item.quantity }; });

    confirmErrorEl.style.display = 'none';
    confirmSubmitBtn.disabled = true;
    confirmSubmitBtn.textContent = '...';
    confirmBackBtn.disabled = true;

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: phone, line_items: items, source: pendingConfirmContext.source || 'cart_drawer', cart_token: cart.token || null, customer_id: window.__CUSTOMER_ID || null })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          closeConfirmModal(false);
          if (typeof closeThemeModal === 'function') closeThemeModal();
          fetch('/cart/clear.js', { method: 'POST' }).then(function () {
            var cartCount = document.querySelector('.cart-link__count, .cart-count');
            if (cartCount) cartCount.textContent = '0';
            var cartIcon = document.querySelector('#site-control .cart:not(.nav-search) .cart-link__count');
            if (cartIcon) cartIcon.textContent = '0';
          });
          showOneClickSuccessToast();
        } else {
          confirmErrorEl.textContent = data.error || (window.__T?.one_click?.confirm?.error || 'An error occurred. Please try again.');
          confirmErrorEl.style.display = '';
          confirmSubmitBtn.disabled = false;
          confirmSubmitBtn.textContent = confirmSubmitDefaultText;
          confirmBackBtn.disabled = false;
        }
      })
      .catch(function () {
        confirmErrorEl.textContent = window.__T?.one_click?.confirm?.error || 'An error occurred. Please try again.';
        confirmErrorEl.style.display = '';
        confirmSubmitBtn.disabled = false;
        confirmSubmitBtn.textContent = confirmSubmitDefaultText;
        confirmBackBtn.disabled = false;
      });
  }

  if (confirmOverlay) {
    confirmSubmitBtn.addEventListener('click', submitOneClickOrder);
    confirmBackBtn.addEventListener('click', function () { closeConfirmModal(true); });
    confirmOverlay.addEventListener('click', function (e) {
      if (e.target === confirmOverlay) closeConfirmModal(true);
    });
  }

  // Cart drawer inline one-click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.one-click-drawer__btn');
    if (!btn) return;

    var drawer = btn.closest('.one-click-drawer');
    var input = drawer.querySelector('.one-click-drawer__phone');
    var errorEl = drawer.querySelector('.one-click-drawer__error');

    errorEl.style.display = 'none';

    var phone = validatePhone(input.value);
    if (!phone) {
      errorEl.textContent = window.__T?.one_click?.inline?.invalid_phone || 'Please enter a valid phone number.';
      errorEl.style.display = '';
      return;
    }

    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        openConfirmModal(phone, cart, btn);
      })
      .catch(function () {
        errorEl.textContent = window.__T?.one_click?.inline?.error || 'An error occurred. Please try again.';
        errorEl.style.display = '';
        btn.disabled = false;
        btn.textContent = window.__T?.one_click?.drawer?.button || 'ORDER';
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('one-click-drawer__phone')) {
      var btn = e.target.closest('.one-click-drawer').querySelector('.one-click-drawer__btn');
      btn.click();
    }
  });

  // Cart page buttons
  document.querySelectorAll('[data-one-click-buy-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var items = cart.items
            .filter(function (item) { return item.product_id !== 8831134531921; })
            .map(function (item) {
              return {
                variant_id: item.variant_id,
                quantity: item.quantity,
                title: item.product_title + (item.variant_title ? ' - ' + item.variant_title : ''),
                price: item.final_price
              };
            });

          if (items.length) {
            openModal(items, 'cart_page');
          }
        });
    });
  });
})();
